import _reverse from "lodash/reverse";
import * as localForage from "localforage";

export default {
  data() {
    return {
      mixins_global_search_historyList: []
    }
  },
  methods: {
    async mixins_global_search_history(keyword) {
      let storageData = await localForage.getItem('global-search-history') || []
      let currentFundIndex = storageData.indexOf(keyword)
      if (currentFundIndex !== -1) {
        storageData.splice(currentFundIndex, 1)
      }

      if (storageData.length > 4) {
        let startElem = storageData.length - 4 >= 0 ? storageData.length - 4 : 0;
        storageData = storageData.splice(startElem, 4)
      }

      storageData.push(keyword)
      await localForage.setItem('global-search-history', storageData)
    },
    async mixins_global_search_getHistory() {
      let historyList = await localForage.getItem('global-search-history')
      if (historyList && historyList.length > 0) {
        this.mixins_global_search_historyList = _reverse(historyList)
      }
    },
    async mixins_global_search_clearHistory(confirmDelete) {
      if (confirmDelete) {
        localForage.removeItem('global-search-history')
        this.mixins_global_search_historyList = null
      }
    }
  }

}
